module.exports = __webpack_public_path__ + "static/Animals-323047586df88210133173dccb4bd312.mp4";